import Http from "./../http";
/**
 * [feedRecordsApi description]
 * @method xxx @for @param {object} [params]  @return {Array} 返回数据
 * @var {[get]}
 */
const feedRecordsApi = {
    // 获取分类列表 当前库存
    getMilkInventory: (params, callback) => {
        Http.get("/babyBarn/findRepertory", params, res => {
            // Http.get("/babyBarn/InitMilkPowder", params, res => {
            callback(res);
        })
    },
    // 宝宝粮仓添加记录tabs
    postAddRecord: (urlParams, params, callback) => {
        Http.post("/babyBarn/findAddHistory", urlParams, params, res => {
            callback(res);
        })
    },
    // 获取历史库存
    getHistoryRepertory(params, callback) {
        Http.get("/babyBarn/findHistoryRepertory", params, res => {
            callback(res);
        })
    },
    // 修改库存记录
    postUpdateRepertory: (urlParams, params, callback) => {
        Http.post("/babyBarn/updateRepertory", urlParams, params, res => {
            callback(res);
        })
    },
    // 设为当前在吃
    getNowEat(params, callback) {
        Http.get("/babyBarn/setNowEat", params, res => {
            callback(res);
        })
    },
    // 添加奶粉接口
    postManuallyAdd(urlParams, params, callback) {
        Http.post("/babyBarn/addProduct", urlParams, params, res => {
            callback(res);
        })
    },
    // 删除为0的库存
    getDelRepertory: (params, callback) => {
        Http.get("/babyBarn/deleteRepertory", params, res => {
            callback(res);
        })
    },
    // 科学喂养轮播图
    getFeedBanner(params, callback) {
        Http.get("/feedDiary/findByModuleType", params, res => {
            // Http.get("/babyBarn/InitMilkPowder", params, res => {
            callback(res);
        })
    },
    // 科学喂养文章列表
    postFeedArticleList: (urlParams, params, callback) => {
        Http.post("/scientifiFeeding/articleList", urlParams, params, res => {
            callback(res);
        })
    },
    // 喂养计划 删除提醒
    getDeleteFeedingRemind: (params, callback) => {
        Http.get('/feedingRemind/deleteFeedingRemind', params, res => {
            callback(res)
        })
    },
    // 喂养计划 查询全部喂养提醒
    getFindAllFeedingRemind: (params, callback) => {
        Http.get('/feedingRemind/findAllFeedingRemind', params, res => {
            callback(res)
        })
    },
    // 添加/修改喂养提醒（
    postAddFeedingRemind: (urlParams, params, callback) => {
        Http.post('/feedingRemind/addFeedingRemind', urlParams, params, res => {
            callback(res)
        })
    },
}

export default feedRecordsApi;